import React from 'react';
import './style.css';

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  rowsPerPage: number; // Added rowsPerPage prop
  onRowsPerPageChange: (limit: number) => void; // Added handler for rowsPerPage change
}

const Pagination: React.FC<PaginationProps> = ({ currentPage, totalPages, onPageChange, rowsPerPage, onRowsPerPageChange }) => {
  if (totalPages <= 1) return null;

  const generatePages = () => {
    const pages = [];
    const maxVisiblePages = 7; // Maximum number of visible pages
    const sidePages = Math.floor((maxVisiblePages - 1) / 2); // Pages on each side of the current page

    if (totalPages <= maxVisiblePages) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (currentPage > sidePages + 1) {
        pages.push(1);
        if (currentPage > sidePages + 2) {
          pages.push('...');
        }
      }

      const startPage = Math.max(2, currentPage - sidePages);
      const endPage = Math.min(totalPages - 1, currentPage + sidePages);

      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }

      if (currentPage < totalPages - sidePages) {
        if (currentPage < totalPages - sidePages - 1) {
          pages.push('...');
        }
        pages.push(totalPages);
      }
    }

    return pages;
  };

  const pages = generatePages();

  return (
    <nav className="pagination">
      <div className="limit-selector">
        {/* <label htmlFor="limit-select">Items per page:</label> */}
        <select
          id="limit-select"
          value={rowsPerPage}
          onChange={(e) => onRowsPerPageChange(Number(e.target.value))}
          className="limit-select"
        >
          <option value={10}>10</option>
          <option value={25}>25</option>
          <option value={50}>50</option>
          <option value={100}>100</option>
        </select>
      </div>
      
      <button
        className="pagination-btn"
        disabled={currentPage === 1}
        onClick={() => onPageChange(currentPage - 1)}
      >
        &laquo;
      </button>

      {pages.map((page, index) => (
        <button
          key={index}
          className={`pagination-btn${page === currentPage ? ' active' : ''}`}
          onClick={() => typeof page === 'number' && onPageChange(page)}
          disabled={typeof page !== 'number'}
        >
          {page}
        </button>
      ))}

      <button
        className="pagination-btn"
        disabled={currentPage === totalPages}
        onClick={() => onPageChange(currentPage + 1)}
      >
        &raquo;
      </button>
    </nav>
  );
};

export default Pagination;
